import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Accordion, Link, Text } from '@nxt-costco-com/forge-components';
import { mdSpacedBox } from 'src/constants/styles';

export const IntroAccordion: FC = () => {
    const { t } = useTranslation('translation');
    const privacyPolicyTestId = 'privacy-policy';
    const accordionIntro = t('accordians.intro.description', { returnObjects: true });

    const introContent =
        <Box sx={mdSpacedBox}>
            {Object.entries(accordionIntro).map(([key, paragraph]) => (
            <Text key={key} variant='b2'>
                <Trans
                    i18nKey={`accordians.intro.description.${key}`}
                    values={{ privacyPolicy: t('accordians.privacyPolicy') }}
                    components={{
                        1: (
                            <Link
                                href={t('links.privacySrc')}
                                uniqueId={`intro-${privacyPolicyTestId}`}
                                underline="always"
                                color="#3860be"
                            >
                                Privacy Policy
                            </Link>
                        ),
                    }}
                >
                    {paragraph}
                </Trans>
            </Text>
        ))}
    </Box>

    return (
        <Accordion title={t('accordians.intro.name')} variant={'t5'}>
            { introContent }
        </Accordion>
    );
};
